import { INGChipGroupProps } from "../../library/NGFieldExtensions";
import { Stack, Chip, Tooltip } from "@mui/material";
import { publishUserAction } from "../../library/analytics";
import { useSignal } from "@preact/signals-react";
import { getTestId, getFirstNonEmpty, partitionMUIClasses, getClassName } from "../../library/utils";
import { isNil, isObject } from "lodash-es";
import { setupHandlers, setupLocalState } from "../../library/dataService";

export default function NGChipGroup({ context, config }: INGChipGroupProps) {
  const tag = "NGChipGroup";
  const local = setupLocalState(
    config,
    {
      Label: useSignal(config.Label ?? ""),
      Title: useSignal(config.Title ?? null),
      Value: useSignal(config.DefaultValue ?? ""),
      MultiSelectPossibleValues: useSignal(config.MultiSelectPossibleValues ?? []),
      Classes: useSignal(config.Classes ?? ""),
      Style: useSignal(config.Style ?? {}),
    },
    context
  );

  const handlers = setupHandlers(config, context);

  const handleClick = (e, v: any) => {

    const [_, classes] = partitionMUIClasses(local.Classes.value);
    const action = publishUserAction(config, context, "button_click", e, {
      ElementText: getFirstNonEmpty(
        local.Label.value,
        local.Title.value,
      ),
      EventCategory: "engagement",
      ElementClass: classes.join(" "),
    });

    if(Array.isArray(local.Value?.value) && local.Value.value.includes(v)) {
      local.Value.value = local.Value.value.filter(item => item !== v);
      if (handlers["onClick"]) handlers["onClick"](e, local.Value.value, action);
      return;
    }

    if(!config.Multiple) {
      local.Value.value = [v];
    } else {      
      local.Value.value = [...local.Value.value, v];
    }
    if (handlers["onClick"]) handlers["onClick"](e, local.Value.value, action);

  };

  return (
    <>
      <Stack
        data-testid={getTestId(config)} 
        data-type={config.__typename}
        className={`${getClassName(local.Classes)}`} 
        direction="row" style={{ flexWrap: "wrap" }} 
        spacing={1}>
        {(local.MultiSelectPossibleValues.value ?? [])?.map((datum: any, index) => {
                    let value = datum;
                    let label = null;
                    let tooltip = null;

                    if (isObject(datum) && !isNil(config.ValueExpression)) {
                      value = datum[config.ValueExpression];
                      label = datum[config.LabelExpression || ""];
                      tooltip = datum[config.TooltipExpression || ""];
                    }

                  if (tooltip) {
                    return (
                  <Tooltip title={tooltip} key={index}>
                    <Chip
                      color="primary"
                      onClick={(event) => handleClick(event, value)}
                      variant={local.Value?.value?.includes(value) ? "filled" : "outlined"}
                      label={label || value}
                      />
                  </Tooltip>);
                  } else {
                    return (
                      <Chip
                        color="primary"
                        onClick={(event) => handleClick(event, value)}
                        variant={local.Value?.value?.includes(value) ? "filled" : "outlined"}
                        label={label || value}
                        key={index}
                      />
                    );
                  }
                })}
        
      </Stack>
    </>
  );
}
